import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateOcorrenciaColumnsDefinition
 */

type Props = {
  lockFuncionarioAprovado: boolean;
  statusChecklistServico: number | null;
  onActionEditar: (idInformacoesInspecaoObra: number | null, idInspecaoObraItens: number | null, openState: boolean) => void;
  onActionDeletar: (idInformacoesInspecaoObra: number | null, openState: boolean) => void;
};

export const GenerateOcorrenciaColumnsDefinition = ({
  lockFuncionarioAprovado,
  statusChecklistServico,
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "descricao",
      filterable: false,
      headerName: "Descrição",
      flex: 1,
      minWidth: 120,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex flex-row items-center py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "data",
      filterable: false,
      headerName: "Data",
      width: 90,
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex flex-row items-center py-2">
            {value ? dayjs(value).format('DD/MM/YYYY') : null}
          </div>
        );
      }
    },
    {
      field: "tratativa",
      filterable: false,
      headerName: "Tratativa",
      flex: 1,
      minWidth: 200,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex flex-row items-center py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "dataTratativa",
      filterable: false,
      headerName: "Data",
      width: 90,
      minWidth: 90,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex flex-row items-center py-2">
            {value ? dayjs(value).format('DD/MM/YYYY') : null}
          </div>
        );
      }
    },
    {
      field: "itemInspecao",
      filterable: false,
      headerName: "Item de Inspeção",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex flex-row items-center py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: "inspecao",
      filterable: false,
      headerName: "Inspeção",
      minWidth: 100,
      width: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <div className="w-full h-full flex flex-row items-center py-2">
            {value}
          </div>
        );
      }
    },
    {
      field: 'idInformacoesInspecaoObra',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              disabled={statusChecklistServico === 1 || lockFuncionarioAprovado}
              onClick={() => onActionEditar(params.value, null, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton
              disabled={statusChecklistServico === 1 || lockFuncionarioAprovado}
              onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}